import PropTypes from 'prop-types';

import FormGroup from '@mui/material/FormGroup';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import FormHelperText from '@mui/material/FormHelperText';

const CheckboxGroup = (props) => {
	const {
		name,
		value,
		label,
		error,
		helperText,
		group,
		onChange,
		options = [],
	} = props;

	return (
		<Stack spacing={1}>
			{label && <InputLabel>{label}</InputLabel>}
			<FormControl>
				<FormGroup name={name} sx={{ pl: 0.5 }} {...group}>
					{options.map((option) => {
						return (
							<FormControlLabel
								key={option.value}
								value={option.value}
								label={option.label}
								onChange={onChange}
								sx={{ ' .MuiFormControlLabel-label': { lineHeight: 1.4 } }}
								control={
									<Checkbox
										color={error ? 'error' : undefined}
										sx={{ color: error ? 'error.main' : undefined }}
										checked={
											value ? value.includes(String(option.value)) : undefined
										}
										{...option.checkbox}
									/>
								}
							/>
						);
					})}
				</FormGroup>
				{helperText && <FormHelperText>{helperText}</FormHelperText>}
				{typeof error === 'string' && error && (
					<FormHelperText error>{error}</FormHelperText>
				)}
			</FormControl>
		</Stack>
	);
};

CheckboxGroup.propTypes = {
	name: PropTypes.string,
	value: PropTypes.arrayOf(PropTypes.string),
	label: PropTypes.string,
	error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
	helperText: PropTypes.string,
	group: PropTypes.shape(FormGroup.propTypes),
	onChange: PropTypes.func,
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
			label: PropTypes.node,
			checkbox: PropTypes.shape(Checkbox.propTypes),
		}),
	),
};

export default CheckboxGroup;
